var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDislikeDisabledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.936035C24.5604 0.936035 31.5 7.87562 31.5 16.436C31.5 24.9964 24.5604 31.936 16 31.936C7.43959 31.936 0.5 24.9964 0.5 16.436C0.5 7.87562 7.43959 0.936035 16 0.936035Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.936035C24.5604 0.936035 31.5 7.87562 31.5 16.436C31.5 24.9964 24.5604 31.936 16 31.936C7.43959 31.936 0.5 24.9964 0.5 16.436C0.5 7.87562 7.43959 0.936035 16 0.936035Z",
    stroke: "#D9DCE1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6665 15.6029C7.6665 16.5233 8.4127 17.2695 9.33317 17.2695C10.7139 17.2695 11.8332 16.1502 11.8332 14.7695V11.4362C11.8332 10.0555 10.7139 8.9362 9.33317 8.9362C8.4127 8.9362 7.6665 9.68239 7.6665 10.6029V15.6029Z",
    stroke: "#ADB3BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8986 19.514L18.6767 18.7973C18.4949 18.2099 18.4039 17.9163 18.4739 17.6844C18.5304 17.4967 18.6546 17.335 18.8238 17.2286C19.033 17.0971 19.3494 17.0971 19.9823 17.0971H20.3189C22.4606 17.0971 23.5315 17.0971 24.0373 16.4631C24.0951 16.3907 24.1465 16.3136 24.191 16.2328C24.5801 15.5258 24.1377 14.5733 23.253 12.6683C22.4411 10.9201 22.0351 10.0461 21.2814 9.53158C21.2084 9.48177 21.1334 9.43479 21.0566 9.39076C20.263 8.93587 19.2798 8.93587 17.3133 8.93587H16.8868C14.5044 8.93587 13.3132 8.93587 12.5731 9.65298C11.833 10.3701 11.833 11.5243 11.833 13.8326V14.6439C11.833 15.857 11.833 16.4636 12.0483 17.0187C12.2636 17.5739 12.6758 18.0303 13.5003 18.9433L16.9098 22.7187C16.9953 22.8134 17.038 22.8608 17.0757 22.8936C17.4276 23.1998 17.9707 23.1653 18.2783 22.8173C18.3113 22.78 18.3473 22.7276 18.4194 22.6229C18.532 22.4592 18.5884 22.3773 18.6375 22.2962C19.077 21.5699 19.21 20.7072 19.0087 19.8882C18.9862 19.7968 18.957 19.7025 18.8986 19.514Z",
    stroke: "#ADB3BD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeDisabledIcon);
export default __webpack_public_path__ + "static/media/dislike-disabled-icon.08b2b855b8ad87193d3d1fa7e86ac433.svg";
export { ForwardRef as ReactComponent };